import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Activity, RefreshCw } from 'lucide-react';
import DukeSlider from './DukeSlider';

/**
 * DukeSliderDemo - Minimal showcase for the Physical Function Assessment
 * 
 * A clean, focused demo page that lets the slider component shine
 * without unnecessary distractions.
 */
const DukeSliderDemo = () => {
  const [readOnly, setReadOnly] = useState(false);
  
  // Sample data for demo
  const demoData = {
    score: { t: 52, date: new Date() },
    history: [
      { t: 45, date: new Date(Date.now() - 864e5 * 90) },
      { t: 48, date: new Date(Date.now() - 864e5 * 45) },
      { t: 50, date: new Date(Date.now() - 864e5 * 15) }
    ]
  };

  // Handle demo reset
  const resetDemo = () => {
    localStorage.removeItem('duke_pf_goals_v3');
    localStorage.removeItem('duke_pf_opts_v3');
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-6">
      <div className="max-w-[1600px] mx-auto w-full">
        {/* Main Slider Component - no header */}
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          className="mb-6 w-full"
        >
          <DukeSlider
            score={demoData.score}
            history={demoData.history}
            readOnly={readOnly}
            className="w-full"
          />
        </motion.div>

        {/* Minimal Controls */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="flex items-center justify-center space-x-6"
        >
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="checkbox"
              checked={readOnly}
              onChange={(e) => setReadOnly(e.target.checked)}
              className="w-4 h-4 text-primary-600 rounded focus:ring-primary-500"
            />
            <span className="text-sm text-gray-700">Read-only mode</span>
          </label>
          
          <button
            onClick={resetDemo}
            className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            <span>Reset</span>
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default DukeSliderDemo;